import { Box } from '@mui/material';
import { theme } from '../App';

export default function MaxWidthWrapper({ children }) {
  return (
    <Box
      sx={{
        maxWidth: theme.custom.maxWidth,
        margin: '0 auto',
        width: '100%',
      }}
    >
      {children}
    </Box>
  );
} 